/*! @azure/msal-browser v2.24.0 2022-05-02 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.24.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
